module.exports = __webpack_public_path__ + "img/btn_xuanzhuan_ov.7d60dfdf.png";